<template>
  <form @submit.prevent="submit">
    <div class="login login-body">
      <div class="login-box d-flex align-items-center justify-content-center flex-column">
        <h2 class="fw-bolder mb-lg-5 mb-4">CommerceLab</h2>
        <!-- <div class="form-group"> -->
          <!-- <base-input :type="text" inputId="username" /> -->
          <base-input id="username" class="mb-4" placeholder="Username"
            :modelValue="form.user"
            @update:modelValue="value => form.user = value" />
          <base-input type="password" id="password" placeholder="Password"
            :modelValue="form.pass"
            @update:modelValue="value => form.pass = value" />
        <!-- </div> -->
        <div class="d-flex align-items-center justify-content-between form-group pt-4">
          <base-link :linkText="'Forgot Password ?'" />
          <base-button type="submit" :loading="loading">
            Login
          </base-button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
// @ is an alias to /src
import { mapActions } from 'vuex'
import BaseInput from '@/components/input/BaseInput.vue';
import BaseLink from '@/components/BaseLink.vue';
import BaseButton from '@/components/BaseButton.vue';

import { useToast } from "vue-toastification";

export default {
  setup() {
    const toast = useToast();
                
    //   // Use it!
    //   toast("I'm a toast!");

    //   // or with options
    //   toast.success("My toast content", {
    //     timeout: 2000
    //   });
    return { toast }
  },
  data(){
    return {
      loading: false,
      form: {
        user: '',
        pass: ''
      }
    }
  },
  name: 'LoginView',
  components: {
    BaseInput,
    BaseButton,
    BaseLink
  },
  methods: {
    ...mapActions(['login']),
    async submit() {
      if (this.form.user && this.form.user) {
        const user = new FormData();
        user.append('email', this.form.user)
        user.append('password', this.form.pass)

        // console.log(this.$loading)
        let loader = this.$loading.show()
        // try {
        //   await this.login(user);
          // this
          this.$router.push('home')
        // } catch (error) {
        //   // console.log(error)
        //   this.toast.error(error.response.data.message)
        // }
        loader.hide()
      } else {
          this.toast.error('Empty required field.')
      }
    }
  }
}
</script>
<style lang="scss">
@import "@/assets/scss/mixin/_prefix.scss";
@import '@/assets/scss/custom/login.scss';
</style>
